import React, { useEffect, useState } from 'react';
import { Input, Switch, Button, Space, Select, Typography } from 'antd';
import { filterOption } from 'modules/utilities/utility';
import { ReloadOutlined } from '@ant-design/icons';
import { get } from 'lodash';
import { useWabaMessageList } from './store';
import TestWaba from './TestWaba';
const { Text } = Typography;

const options = [
     { label: 'Text', value: 'text' },
     { label: 'Image', value: 'Image' },
     { label: 'Video', value: 'video' },
     { label: 'Document', value: 'Document' }
 ];

const WABAForm = ({ operation, waba }) => {
    const { updateWaba, createWaba } = useWabaMessageList();
    const [formData, setFormData] = useState({
        key: '',
        template_id: '',
        type: '',
        button_url: '',
        cta: false,
        dynamic: false,
        static: false,
        body: ''
    });

    useEffect(() => {
        if (waba) {
            setFormData({
                key: get(waba, 'key', ''),
                template_id: get(waba, 'template_id', ''),
                type: get(waba, 'type', ''),
                button_url: get(waba, 'button_url', ''),
                static: get(waba, 'static', false),
                dynamic: get(waba, 'dynamic', false),
                cta: get(waba, 'cta', false),
                body: get(waba, 'body', '')
            });
        }
    }, [waba]);
    
    const [sendTo, setSendTo] = useState(null);

    const handleInputChange = (field, value) => {
        setFormData(prevData => ({
            ...prevData,
            [field]: value
        }));
    };

    const submitValidation = (btn) =>{
        const {key, template_id, type, cta, button_url, body } = formData;
        if(!key || !template_id || !type || !body){
            return true;
        }
        if(btn === 'send'){
            if(!sendTo){
                return true;
            }
            const trimmedInput = sendTo.trim();
            const phoneRegex = /^\d{10}$/;
            // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            // const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
            return !(phoneRegex.test(trimmedInput));
            //  || emailRegex.test(trimmedInput) || uuidRegex.test(trimmedInput));
        } else {
            if(cta && !button_url){
                return true
            }
            return false;
        }        
    }

    return (
        <div>
            <Space.Compact block className='my-3'>
                <span
                    style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                    <Text>Enter Template Id</Text>
                </span>
                <Input
                    style={{ width: '70%' }}
                    allowClear
                    value={formData.template_id}
                    placeholder='Template Id'
                    onChange={event => handleInputChange('template_id', event.target.value)}
                />
            </Space.Compact>
            <Space.Compact block className='mb-3'>
                <span
                    style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                    <Text>Enter Key</Text>
                </span>
                <Input
                    style={{ width: '70%' }}
                    allowClear
                    value={formData.key}
                    placeholder='Key'
                    onChange={event => handleInputChange('key', event.target.value)}
                />
            </Space.Compact>
            <Space.Compact block className='my-3'>
                <span
                    style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                    <Text>Select Type</Text>
                </span>
                <Select
                    style={{ width: '70%' }}
                    showSearch
                    allowClear
                    value={formData.type}
                    placeholder='Select Type'
                    optionFilterProp='children'
                    onChange={value => handleInputChange('type', value)}
                    filterOption={filterOption}
                    options={options}
                />
            </Space.Compact>
            <div className='d-flex justify-content-between gap-3'>
                <div className='d-flex justify-content-between flex-1 px-3 py-2' style={{ border: '1.75px solid #D9D9D9', borderRadius: '5px'}}>
                    <Text>CTA </Text>
                    <Switch checked={formData.cta} onChange={value => handleInputChange('cta', value)}/>
                </div>
                {waba ? (
                    <div className='d-flex justify-content-between flex-1 px-3 py-2' style={{ border: '1.75px solid #D9D9D9', borderRadius: '5px'}}>
                        <Text>Static </Text>
                        <Switch checked={formData.static} onChange={value => handleInputChange('static', value)}/>
                    </div>
                ) : (
                    <div className='d-flex justify-content-between flex-1 px-3 py-2' style={{ border: '1.75px solid #D9D9D9', borderRadius: '5px'}}>
                        <Text>Static </Text>
                        <Switch onChange={value => handleInputChange('static', value)}/>
                    </div>
                )}
                {waba ? (
                    <div className='d-flex justify-content-between flex-1 px-3 py-2' style={{ border: '1.75px solid #D9D9D9', borderRadius: '5px'}}>
                        <Text>Dynamic </Text>
                        <Switch checked={formData.dynamic} onChange={value => handleInputChange('dynamic', value)}/>
                    </div>
                ) : (
                    <div className='d-flex justify-content-between flex-1 px-3 py-2' style={{ border: '1.75px solid #D9D9D9', borderRadius: '5px'}}>
                        <Text>Dynamic </Text>
                        <Switch onChange={value => handleInputChange('dynamic', value)}/>
                    </div>
                )}
            </div>
           {formData.cta && <Space.Compact block className='my-3'>
                <span
                    style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                    <Text>Button URL</Text>
                </span>
                <Input
                    style={{ width: '70%' }}
                    allowClear
                    value={formData.button_url}
                    placeholder='Button URL'
                    onChange={event => handleInputChange('button_url', event.target.value)}
                />
            </Space.Compact>}
            <div className='my-3'>
                <Input.TextArea 
                    value={formData.body} 
                    placeholder='Message body' 
                    autoSize={{ minRows: 16, maxRows: 16 }} 
                    onChange={(event) => handleInputChange('body', event.target.value)} 
                    rows={19} 
                    className='-mt-2'
                />
            </div>
            {operation === 'create' ? 
                <Button className='w-100' type="primary" disabled={submitValidation('create')} onClick={()=>{createWaba(formData)}}>Create WABA</Button> :
                <div className='d-flex gap-2'>
                <Button className='flex-1' disabled={submitValidation('update')} onClick={()=>{updateWaba(waba._id, formData)}} type="primary">Update <ReloadOutlined /></Button>
                    <TestWaba waba={formData} className='flex-1' submitValidation={submitValidation} setSendTo={setSendTo} sendTo={sendTo}/>
                </div>
            }
        </div>
    )
}

export default WABAForm